<script>
    import Chart from "chart.js";
    import {Bar, mixins} from 'vue-chartjs';

    Chart.defaults.global.defaultFontFamily = "'Montserrat', sans-serif";

    export default {
        props: ['options'],
        extends: Bar,
        mixins: [mixins.reactiveProp],
        mounted() {
            Chart.Legend.prototype.afterFit = function () {
                this.height = 30;
            };
            this.renderChart(this.chartData, this.options)
        }
    }
</script>